module.exports = __webpack_public_path__ + "img/hikParkAd.284c9f4e.png";